import { render, staticRenderFns } from "./RouteChannelInfoEdit.vue?vue&type=template&id=f0a15138&scoped=true&"
import script from "./RouteChannelInfoEdit.vue?vue&type=script&lang=js&"
export * from "./RouteChannelInfoEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0a15138",
  null
  
)

export default component.exports